module.exports = __webpack_public_path__ + "static/media/leaf.a0f87872.svg";